import { Canvas } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { Suspense } from "react";
import { Tombstone } from "./Tombstone";
import { ENV } from "./layout";

export const StonePreview = ({ memorial, env = "garden", testId = "stone-preview", height = "h-[420px]" }) => {
  const cfg = ENV[env];
  return (
    <div className={`relative w-full ${height} rounded-3xl overflow-hidden scene-canvas`} data-testid={testId} style={{ background: `linear-gradient(180deg, ${cfg.fog[0]} 0%, #f3ead9 100%)` }}>
      <Canvas camera={{ position: [0, 1.15, 3.1], fov: 38 }} dpr={[1, 1.75]} shadows>
        <Suspense fallback={null}>
          <hemisphereLight args={cfg.hemi} />
          <directionalLight position={[2.5, 4, 3.5]} intensity={2.1} color={cfg.light.color} castShadow shadow-mapSize={[1024, 1024]} />
          <ambientLight intensity={0.25} />
          <mesh rotation={[-Math.PI / 2, 0, 0]} receiveShadow>
            <circleGeometry args={[2.4, 48]} />
            <meshStandardMaterial color={cfg.ground[1]} roughness={1} />
          </mesh>
          <Tombstone memorial={memorial} position={[0, 0, 0]} />
          <OrbitControls target={[0, 0.85, 0]} enablePan={false} minDistance={1.6} maxDistance={5} maxPolarAngle={1.5} autoRotate={false} />
        </Suspense>
      </Canvas>
    </div>
  );
};
